/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// -----------------------------------------------------------------------------
// Mesure des clics de contact (téléphone, WhatsApp, e-mail).
//
// Les 64 éléments concernés portaient déjà `data-track="<événement>"` et, pour la
// plupart, `data-source="<emplacement>"` — mais RIEN ne lisait ces attributs :
// aucun écouteur, aucun push dataLayer. GA4 ne recevait donc que ses événements
// automatiques (4,4 par utilisateur : session_start, first_visit, page_view,
// user_engagement, scroll), et aucune conversion n'était mesurable depuis
// janvier 2026 — la section « Événements clés » des rapports est restée vide.
//
// Pourquoi ici et pas dans GTM : GA4 (G-JPHR3M923C) est chargé directement par
// gtag() depuis CookieConsent et est ABSENT du conteneur GTM, qui ne porte que la
// conversion Google Ads. Un déclencheur de clic défini dans GTM n'aurait donc
// jamais pu alimenter GA4. D'où cet écouteur unique, délégué au document.
// -----------------------------------------------------------------------------

const TRACK_SELECTOR = '[data-track]';

function trackContactClick(event) {
  const { target } = event;
  // `closest` n'existe que sur les Element : un clic peut cibler autre chose.
  if (!target || typeof target.closest !== 'function') return;

  const el = target.closest(TRACK_SELECTOR);
  if (!el) return;

  const name = el.getAttribute('data-track');
  if (!name) return;

  const payload = {
    // Emplacement précis du CTA (ex. « blog_gratuit_intro », « cta_banner »),
    // pour comparer le rendement des blocs entre eux.
    source: el.getAttribute('data-source') || 'non_renseigne',
    page_path: window.location.pathname,
    link_url: el.getAttribute('href') || '',
  };

  // dataLayer d'abord : GTM (conversion Google Ads) peut s'y brancher plus tard
  // sans retoucher au code.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...payload });

  // Puis GA4. `window.gtag` est défini très tôt dans le <head> par le script
  // Consent Mode (gatsby-ssr.js), l'appel est donc sûr. Sans consentement
  // analytique la bibliothèque GA4 n'est pas chargée : l'événement n'est pas
  // envoyé. Les clics mesurés sont donc minorés du même taux que les sessions
  // (~60 % de couverture), mais la COMPARAISON entre emplacements reste valide.
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, payload);
  }
}

export const onClientEntry = () => {
  // `capture: true` pour enregistrer l'événement avant qu'un handler applicatif
  // n'appelle stopPropagation, et avant la navigation déclenchée par les liens
  // `tel:` / `mailto:` / WhatsApp.
  // Écouteur posé sur `document` : il survit aux changements de route Gatsby,
  // inutile de le reposer à chaque navigation.
  document.addEventListener('click', trackContactClick, { capture: true });
};
